import React from 'react';
import { useLabels, useSitemap } from 'wsm-common-data';

const SITEMAP_KEY = 'LOCATIONS_LIST';
const FALLBACK_URL = '/locations-list.htm';

const SearchUnavailableContent = () => {
	const labels = useLabels();
	const sitemap = useSitemap();

	const repairsText = labels.get('SEARCH_ENGINE_IN_REPAIRS');
	const allLocationText = labels.get('LOCATIONS_VIEW_ALL');
	const allLocHref = sitemap.get(SITEMAP_KEY) || FALLBACK_URL;

	return (
		<div className="d-flex flex-column align-items-center">
			<p className="mb-4">{repairsText}</p>

			<div>
				<a href={allLocHref} className="btn btn-link text-primary">
					{allLocationText}
				</a>
			</div>
		</div>
	);
};

export default SearchUnavailableContent;
